export default [
  {
    path: "/subscribe",
    name: "subscribe",
    meta: {
      title: "我的订阅",
      requireAuth: true
    },
    component: () => import("./subscribe.vue")
  },
  {
    path: "/subscribe/add",
    name: "subscribe-add",
    meta: {
      title: "添加订阅",
      requireAuth: true
    },
    component: () => import("./add.vue")
  }
];
